var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCross16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.471 3.529a.667.667 0 1 0-.942.942L7.057 8 3.53 11.528a.667.667 0 1 0 .942.943L8 8.943l3.529 3.528a.667.667 0 1 0 .942-.943L8.943 8 12.47 4.47a.667.667 0 1 0-.943-.942L8 7.057z"
})));
export default SvgCross16;